import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsEn from './locales/en/translations.json';
import translationsFr from './locales/fr/translations.json';
import translationsDe from './locales/de/translations.json';
import translationsEs from './locales/es/translations.json';

import translationsId from './locales/id/translations.json';
import translationsIt from './locales/it/translations.json';
import translationsJa from './locales/ja/translations.json';
import translationsPt from './locales/pt/translations.json';

const resources = {
	en: {
		translations: translationsEn
	},
	fr: {
		translations: translationsFr
	},
	de: {
		translations: translationsDe
	},
	es: {
		translations: translationsEs
	},
	in: {
		translations: translationsId
	},
	it: {
		translations: translationsIt
	},
	ja: {
		translations: translationsJa
	},
	pt: {
		translations: translationsPt
	}
};

i18n
	.use(initReactI18next)
	.init({
		fallbackLng: 'en',
		debug: false,
		interpolation: {
			escapeValue: false, // not needed for react
		},
		resources: resources,
		// backend: {
		// 	loadPath: 'locales/{{lng}}/{{ns}}.json',
		// 	allowMultiLoading: false,
		// 	crossDomain: false,
		// 	parse: (data) => {
		// 		console.log(data);
		// 		return JSON.parse(data);
		// 	}
		// },

		ns: ["translations"],
		defaultNS: "translations",
		load: 'languageOnly',
	});
export default i18n;